<template>
  <div class="products-page">
    <!-- Banner -->
    <div class="page_pro_banner">
      <img src="@/assets/images/page_pro_banner.jpg">
      <h3>
        <font>华合半导体为雷达、卫星、移动通信系统提供全产业链芯片IP技术服务</font>
        <span>服务介绍</span>
      </h3>
    </div>

    <!-- 面包屑 -->
    <div class="page_dg">
      <div>
        <left>
          <router-link to="/">主页</router-link> &gt;
          <router-link to="/services">服务介绍</router-link>
        </left>
      </div>
    </div>

    <!-- 产品内容 -->
    <div class="page_pro">
      <!-- 分类导航 -->
      <div class="page_pro_one">
        <dl>
          <dd>
            <router-link to="/about/list?menu=合作案例&type=3">
              <h1><img src="@/assets/images/page_pro_one_tb1.png"></h1>
              <h2><b>合作案例</b><c></c></h2>
            </router-link>
          </dd>
          <dd>
            <router-link to="/services/products?menu=货架IP&type=10">
              <h1><img src="@/assets/images/page_pro_one_tb2.png"></h1>
              <h2><b>货架IP</b><c></c></h2>
            </router-link>
          </dd>
        </dl>
      </div>

      <!-- 产品列表 -->
      <div class="page_pro_list">
        <dl style="cursor: pointer;" @click="goToDetail(product)" v-for="(product, index) in products" :key="index" :class="['p-pr-o', 'target', index % 2 === 0 ? 'one' : 'two', { 'action': true }]">
          <dd>
            <left><img :src="product.newImg"></left>
            <right>
              <h1></h1>
              <h2>{{ product.newNameCn }}</h2>
              <h3>{{ product.newSynopsisCn }}</h3>
            </right>
          </dd>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Services',
  metaInfo: {
    title: '服务介绍_器件模型提取_PDK开发_IP设计服务_南京华合半导体',
    meta: [
      { name: 'description', content: '南京华合半导体提供化合物半导体全产业链服务：器件模型提取、PDK开发、IP设计服务、IP流片、整晶圆测试与挑片、芯片微组装、货架IP等。专业技术团队，丰富的行业经验。' },
      { name: 'keywords', content: '器件模型提取,PDK开发,IP设计服务,IP流片,整晶圆测试,芯片微组装,货架IP,化合物半导体服务,南京华合半导体' },
      { name: 'robots', content: 'index,follow' },
      { property: 'og:title', content: '服务介绍 - 南京华合半导体科技有限公司' },
      { property: 'og:url', content: 'https://huaheic.com/services' }
    ],
    link: [
      { rel: 'canonical', href: 'https://huaheic.com/services' }
    ]
  },
  data() {
    return {
      products: [
        {
          image: require('@/assets/images/1-25112Q03K1Z4.png'),
          title: '自研货架IP(IP\\芯片均可出售)',
          desc: '...'
        },
        {
          image: require('@/assets/images/1-2501021106243A.png'),
          title: 'GaN功放芯片',
          desc: '可定制化不同型号的氮化镓功放芯片。...'
        },
        {
          image: require('@/assets/images/1-250102103S4413.png'),
          title: 'GaAs功放芯片',
          desc: '可定制化不同型号的砷化镓功放芯片。...'
        },
        {
          image: require('@/assets/images/1-2501021156163R.png'),
          title: 'PDK开发',
          desc: '华合半导体具备基于Keysight ADS的PDK开发能力，包括Pcell编写、DRC编写、LVS编写以及模型和PDK加密。...'
        },
        {
          image: require('@/assets/images/1-25010211442L53.png'),
          title: '器件模型提取',
          desc: '华合半导体已开发多种GaAs/GaN工艺的有源和无源商业化工艺制程器件模型：Ø GaAs/GaN HEMT 小信号模型Ø GaAs/GaN HEMT 可缩放大...'
        },
        {
          image: require('@/assets/images/1-250102120Q2196.jpg'),
          title: '芯片微组装',
          desc: '可以为客户定制腔体设计、微组装加工（频率可至W波段）。...'
        }
      ]
    }
  },
  created() {
    this.getService()
  },
  methods: {
    getService() {
      this.$request.get('/wx/news/getServiceList').then(response => {
        this.products = response.data
      })
    },
    goToDetail(product) {
      if(product.newNameEn){
        window.open(product.newNameEn)
        return 
      }
      this.$router.push({
        path: '/services/detail',
        query: { id: product.id, menu: product.newNameCn, type: product.newType }
      })
    }
  }
}
</script>

<style scoped>
.products-page {
  min-height: 100%;
}

/* 淡入动画 */
.target {
  opacity: 0;
  transition: opacity 0.5s ease;
}

.target.action {
  opacity: 1;
}

@media screen and (max-width: 740px) {
    .page_pro_banner {
        height: 150px;
        padding-top: 54px;
    }
    
    
}
</style>
